

export const getDateFromDateTime = (dateTime: string): string | undefined =>  {
    return dateTime && new Date(dateTime).toISOString().split('T')[0];
}

export const getDateTimeUTC = (dateTime: string): string | undefined =>  {
    return dateTime && new Date(dateTime).toISOString().split('Z')[0];
}

export const getDateTimeAtTheEndOfDayUTC = (dateTime: string): string | undefined => {
    const result = new Date(dateTime)
    result.setHours(23,59,59,999);
    return dateTime && result.toISOString().split('Z')[0];
}

export function getPlanLeftDays(expiredDate: number) {
    const today = new Date().toISOString();
    const DAY_UNIT_IN_MILLISECONDS = 24 * 3600 * 1000;

    const diffInMilliseconds = new Date(expiredDate).getTime() - new Date(today).getTime()

    const daysLeft = Math.ceil(diffInMilliseconds / DAY_UNIT_IN_MILLISECONDS);
    return daysLeft;
}

export const getValidDate = (dateValue: any) => {
  if (dateValue instanceof Date && dateValue.toString() !== 'Invalid Date') {
    return dateValue;
  }
  return null;
};

export const getReadableDate = (date?: string | Date | null) => {
  if (!date) return;

  return new Date(date).toLocaleDateString('en-NZ', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}
